import { createApi } from '@reduxjs/toolkit/query/react';
import { Loss } from '@typeRoots/common/loss';
import {
  setLosses,
  createLossSuccess,
  updateLossSuccess,
  deleteLossSuccess,
} from '../slice/lossSlice';
import { baseQueryWithProgress } from 'src/helpers/fetchQueryHelper';

export const lossApi = createApi({
  reducerPath: 'lossApi',
  baseQuery: baseQueryWithProgress,
  tagTypes: ['Losses'],
  endpoints: (builder) => ({
    getLossByCompanyId: builder.query<Loss[], number>({
      query: (companyId) => `/loss/company/${companyId}`,
      async onQueryStarted(_params, { queryFulfilled, dispatch }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setLosses(data));
        } catch (error) {
          console.error('Error fetching losses', error);
        }
      },
      providesTags: ['Losses'],
    }),
    createLoss: builder.mutation<Loss, Loss>({
      query: (loss) => ({
        url: '/loss',
        method: 'POST',
        body: loss,
      }),
      async onQueryStarted(loss, { queryFulfilled, dispatch }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(createLossSuccess(data));
        } catch (error) {
          console.error('Error creating loss', error);
        }
      },
    }),
    updateLoss: builder.mutation<Loss, Partial<Loss> & { id: number }>({
      query: ({ id, ...loss }) => ({
        url: `/loss/${id}`,
        method: 'PATCH',
        body: loss,
      }),
      async onQueryStarted(loss, { queryFulfilled, dispatch }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(updateLossSuccess(data));
        } catch (error) {
          console.error('Error updating loss', error);
        }
      },
    }),
    deleteLoss: builder.mutation<void, number>({
      query: (id) => ({
        url: `/loss/${id}`,
        method: 'DELETE',
      }),
      async onQueryStarted(id, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;
          dispatch(deleteLossSuccess(id));
        } catch (error) {
          console.error('Error deleting loss', error);
        }
      },
    }),
  }),
});

export const {
  useGetLossByCompanyIdQuery,
  useCreateLossMutation,
  useUpdateLossMutation,
  useDeleteLossMutation,
} = lossApi;
